import { Component, OnInit, Inject } from '@angular/core';
import { MedicalFeePaymentEditInfo } from '../../../model/medical-fee/medical-fee-payment-edit-info';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { PdfService } from 'src/app/services/pdf.service';
import { ReportViewer } from 'src/app/model/report-viewer';
import { ResizedEvent } from 'angular-resize-event';

@Component({
  selector: 'app-medical-fee-report-dialog',
  templateUrl: './medical-fee-report-dialog.component.html',
  styleUrls: ['./medical-fee-report-dialog.component.css']
})
export class MedicalFeeReportDialogComponent implements OnInit {

  safeResourceUrl: SafeResourceUrl;
  loading: boolean;

  constructor(public dialogRef: MatDialogRef<MedicalFeeReportDialogComponent>
    , private notificationToastService: NotificationToastService
    , private pdfService: PdfService
    , @Inject(MAT_DIALOG_DATA) public data: ReportViewer) {
  }

  async ngOnInit() {
    try {
      this.loading = true;
       const pdfUrl = this.pdfService.base64ToPdfUrl(this.data.ReportBase64);
       this.safeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Honorario');
    } finally {
      this.loading = false;
    }
  }

  getSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
